// Formatações compartilhadas pelos componentes do plantão

export function money(value) {
  return Number(value || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

// "Y-m-d H:i:s" (horário do servidor) -> Date local sem conversão de fuso
function parse(value) {
  if (!value) {
    return null;
  }
  const parts = String(value).split(/[- :]/);
  if (parts.length < 5) {
    return null;
  }
  return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5] || 0);
}

function pad(value) {
  return String(value).padStart(2, "0");
}

export function dateTime(value) {
  const date = parse(value);
  if (!date) {
    return "–";
  }
  return pad(date.getDate()) + "/" + pad(date.getMonth() + 1) + "/" + date.getFullYear() + " " + pad(date.getHours()) + ":" + pad(date.getMinutes());
}

export function hour(value) {
  const date = parse(value);
  if (!date) {
    return "–";
  }
  return pad(date.getHours()) + ":" + pad(date.getMinutes());
}

// Segundos restantes -> "mm:ss" ou "hh:mm:ss"
export function countdown(seconds) {
  const total = Math.max(0, Math.floor(seconds || 0));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const rest = total % 60;
  if (hours > 0) {
    return hours + ":" + pad(minutes) + ":" + pad(rest);
  }
  return pad(minutes) + ":" + pad(rest);
}
